/**
 * Adds a rectangle with rounded corners to a new path; the caller fills
 * or strokes it. Uses arcTo, which every Canvas 2D supports.
 *
 * @param {CanvasRenderingContext2D} context
 * @param {{ x: number, y: number, width: number, height: number }} rect - CSS px
 * @param {number} radius - CSS px
 */
export const roundedRectPath = (context, { x, y, width, height }, radius) => {
  const cornerRadius = Math.max(0, Math.min(radius, width / 2, height / 2));
  const right = x + width;
  const bottom = y + height;

  context.beginPath();
  context.moveTo(x + cornerRadius, y);
  context.arcTo(right, y, right, bottom, cornerRadius);
  context.arcTo(right, bottom, x, bottom, cornerRadius);
  context.arcTo(x, bottom, x, y, cornerRadius);
  context.arcTo(x, y, right, y, cornerRadius);
  context.closePath();
};
